import script from './Script.js'
import * as api from '../api.js'
import Vue from 'vue'
import moment from 'moment'
import cookie from 'js-cookie'
import storeInstance from '@/store.js'
import { userTokenKey, browserVersion, localLabelKey, sysCodeRules, thirdCodeRules, langs, apiLangKey, langKey, printWarningKey } from './Config.js'
import request from '@/request'
import bwipjs from 'bwip-js'
import tagMixin from '@/mixins/tag'
const messages = {
  'en': {
    action: {
      confirm: 'Confirm ',
      cancel: 'Cancel '
    },
    object: {
      day: ' Days '
    },
    all: {
      hour: ' Hours ',
      minute: ' Minutes ',
      second: ' Seconds '
    }
  },
  'zh-s': {
    action: {
      confirm: '确定',
      cancel: '取消'
    },
    object: {
      day: '天'
    },
    all: {
      hour: '小时',
      minute: '分',
      second: '秒'
    }
  },
  'zh-t': {
    action: {
      confirm: '確定',
      cancel: '取消'
    },
    object: {
      day: '天'
    },
    all: {
      hour: '時',
      minute: '分',
      second: '秒'
    }
  },
}
const isLangMatched = messages && localStorage.getItem(langKey)
let codeRules = null
let codeCanvas = null

const timeModel = {
  timer: null,
  time: 0,
  timeCount: 0,
  interval: 500,
  counts: 60*3*2
}
export default {
  loadSocket() {
    // 加载socket js
    const url = api.socketScript

    return script(url)
  },
  generateColumns(columns, prevs = [], lasts = []) {
    // 根据数据列生成列表头
    const generateHeads = (array) => {
      const heads = []
      array.forEach(i => {
        const item = {
          width: i.width || 'auto',
          label: i.label,
          prop: i.prop || '',
          checked: true,
          sortKey: i.sortKey || '',
          type: i.type || '',
          handle: !!i.handle
        }

        heads.push(item)
      })

      return heads
    }

    const isEN = localStorage.getItem(apiLangKey) === 'en'
    const dataHeads = []
    columns.forEach(column => {
      const item = {
        width: column.width || 'auto',
        label: isEN ? (column.text_en || column.text) : column.text,
        prop: column.column,
        checked: true,
        sortKey: column.order_column
      }

      dataHeads.push(item)
    })

    const prevArray = generateHeads(prevs)
    const lastArray = generateHeads(lasts)
    const tableHeaders = prevArray.concat(dataHeads).concat(lastArray)

    tableHeaders.forEach((item, index) => {
      item.id = index
    })

    return tableHeaders
  },
  getPort() {
    // 当前环境端口
    const { protocol, port } = window.location
    const addedPort = protocol.includes('https') ? 443 : 80
    
    return port || addedPort
  },
  generateApiUrl() {
    // 生成api base url 
    // 正式环境取域名端口或配置，其他环境用配置
    const env = process.env.NODE_ENV
    const { protocol, hostname } = window.location
    const configPort = this.getPort()

    return env.includes('dev') ? '' : `${protocol}//${hostname}:${configPort}`
  },
  generateSocketUrl() {
    // 生成socket base url (只有开发环境使用这个方法，其他环境不传url)
    const { port } = window.location
    const env = process.env.NODE_ENV

    return env.includes('dev') ? `wss://121.4.142.15:${port}/` : ''
  },
  getDict(type) {
    // 获取数据字典，type只有一个的时候传type，多个的时候传type组成的数组；返回值为对象，其中key为type，value为对应数组。
    const tagDefaultConfig = storeInstance.state.exec[491] === 1
    const avoidTranslateTypes = ['612']
    
    return request('get', api.getDict, { type }).then(async (res) => {
      if (res) {
        const data = res
        const isEN = localStorage.getItem(apiLangKey) === 'en'
        if (typeof(type) === 'number') {
          const resData = {}
          if (type === 200) {
            const smartTags = await tagMixin.methods._getSmartTagList.bind(Vue.prototype)()
            const smartTagConfig = smartTags.map(i => {
              return {
                id: 0 - i.id,
                value: 0 - i.id,
                name: i.name,
                is_default: i.is_default
              }
            })

            if (tagDefaultConfig) {
              data.forEach(i => {
                i.is_default = 0
              })
            } else {
              smartTagConfig.forEach(i => {
                i.is_default = 0
              })
            }

            resData[type] = data.concat(smartTagConfig)
          } else {
            resData[type] = data
          }
          
          if (isEN && !avoidTranslateTypes.includes(type)) {
            resData[type].forEach(i => {
              i.name = i.name_en || i.name
              if (i.son && i.son.length) {
                i.son.forEach(s => {
                  s.name = s.name_en || s.name
                })
              }
            })
          }

          return resData
        } else {
          if (type.includes(200)) {
            const smartTags = await tagMixin.methods._getSmartTagList.bind(Vue.prototype)()
            const smartTagConfig = smartTags.map(i => {
              return {
                id: 0 - i.id,
                value: 0 - i.id,
                name: i.name,
                is_default: i.is_default
              }
            })

            if (tagDefaultConfig) {
              (data[200] || []).forEach(i => {
                i.is_default = 0
              })
            } else {
              smartTagConfig.forEach(i => {
                i.is_default = 0
              })
            }

            data[200] = (data[200] || []).concat(smartTagConfig)
          }

          if (isEN) {
            for (const k in data) {
              if (Object.hasOwnProperty.call(data, k)) {
                data[k].forEach(i => {
                  if (!avoidTranslateTypes.includes(k)) {
                    i.name = i.name_en || i.name
                    if (i.son && i.son.length) {
                      i.son.forEach(s => {
                        s.name = s.name_en || s.name
                      })
                    }
                  }
                })
              }
            }
          }

          return data
        }
      }
    })
  },
  scanCodeTransferCenter(code, node) {
    // 扫码处理中心跳转
    if (!code || !node) {
      console.log('缺少参数')

      return   
    }

    const query = { code, node }
    const { scanCodeTransferCenter } = api
    return request('get', scanCodeTransferCenter, query)
    .then(res => {
      const {msg, success} = res
      if (msg) {
        Vue.prototype.$message({
          message: msg,
          type: 'success',
          customClass: 'zIndex-9999'
        })
      }

      return success
    })
  },
  recordUserScan(data) {
    // 记录人员扫码
    const { code, node, type} = data
    if (!code || !node || !type) {
      console.log('缺少参数')

      return   
    }

    const params = { code, node, type }
    const { scanUserCodeLog } = api
    return request('post', scanUserCodeLog, params, { silence: true })
  },
  getCodeRules() {
    // 获取编码规则
    return request('get', api.codeRule).then((res) => {
      if (res) {
        const data = res
        codeRules = res

        return data
      } else {
        return null
      }
    })
  },
  async getCode(code) {
    // 获取编码规则
    if (!code) {
      console.log('code不能为空')
      
      return {}
    }
    
    const sysCodeRuleMatched = sysCodeRules.filter(i => i.content === code)[0]
    if (sysCodeRuleMatched) {
      return sysCodeRuleMatched
    }

    const thirdCodeRuleMathed = thirdCodeRules.filter(i => i.rule.test(code) && (i.length ? i.length === code.length : true)
    )[0]
    if (thirdCodeRuleMathed) {
      return thirdCodeRuleMathed
    }

    const rules = codeRules || await this.getCodeRules()

    if (!rules) {
      console.log('获取编码规则失败')

      return {}
    }

    let rule = null
    rules.forEach((r) => {
      if (code.toLowerCase().startsWith(`${r.prefix}`.toLocaleLowerCase()) && code.length === r.length) {
        rule = Object.assign({}, r)
      }
    })

    return rule || {}
  },
  refreshToken() {
    // 刷新token
    return request('get', api.refreshToken, {}, { silence: true })
  },
  getSysTime() {
    // 获取系统时间
    return request('get', api.systime, {}, { silence: true }).then(res => {
      if (res) {
        const data = res

        return data
      }
      
      return new Date.getTime()
    })
  },
  exportFile(path, obj) {
    // 导出文件
    const params = this.washObject(JSON.parse(JSON.stringify(obj)))
    const paramArray = []
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const value = params[key]
        paramArray.push(`${key}=${value}`)
      }
    }
    const paramString = paramArray.join('&')
    const token = cookie.get(userTokenKey)
    const routerLangKey = localStorage.getItem(apiLangKey) || 'zh_CN';
    let url = `${this.generateApiUrl()}${path}?token=${token}&${paramString}`
    url = url.replace('/api/', `/api/${routerLangKey}/`)

    window.open(url, '_blank')
  },
  sleep(time = 0) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, time)
    })
  },
  async getTime() {
    // 获取时间
    const time = await this.getSysTime()
    timeModel.time = time.timestamp

    this.startClock()
  },
  startClock() {
    // 开始计时
    timeModel.timer = timeModel.timer || setInterval(() => {
      storeInstance.commit('setSystem', {time: timeModel.time})
      timeModel.time += 500
      timeModel.timeCount += 1
      if (timeModel.timeCount > timeModel.counts) { // 重新校对
        clearInterval(timeModel.timer)
        timeModel.timeCount = 0
        timeModel.timer = null

        this.getTime()
      }
    }, 500)
  },
  replaceStringForSpeak(content) {
    // 将文本中的数字和横线转换为汉字，用于朗读
    const s = content.replace(/-/g, '杠').replace(/1/g, '一').replace(/2/g, '二').replace(/3/g, '三').replace(/4/g, '四').replace(/5/g, '五').replace(/6/g, '六').replace(/7/g, '七').replace(/8/g, '八').replace(/9/g, '九').replace(/0/g, '零')

    return s
  },
  speak(string) {
    // 语音播报
    // 支持连续播报或单条播报，默认为不连续
    try {
      const continuousConfig = storeInstance.state.exec[436] === 1
      if (!continuousConfig) {
        window.speechSynthesis.cancel()
      }
      let content = string
      let lang = ''
      let voice = ''
      const voices = window.speechSynthesis.getVoices()
      const selectLang = langs.filter(i => i.localKey === lang)[0]
      if (selectLang) {
        lang = selectLang.voiceKey
        voice = voices.filter(i => i.lang === selectLang.voiceKey)[0] || voices[0]
      } else {
        lang = 'zh-CN'
        voice = voices[0]
      }

      if (lang.includes('zh')) {
        content = this.replaceStringForSpeak(string)
      }
      
      const speaker = new SpeechSynthesisUtterance(content)
      speaker.lang = lang
      speaker.voice = voice

      
      // speaker.rate = 1 // 语速
      // speaker.volume = 1 // 音量
      // speaker.pitch = 1 // 语调
      window.speechSynthesis.speak(speaker)
    } catch (error) {
      console.log('语音报错', error)
    }
  },
  formatTime (total) {
    // 转换时间戳为时间字符串，传入单位为秒
    const dText = isLangMatched ? messages[localStorage.getItem(langKey)]['object']['day'] : '天'
    const hText = isLangMatched ? messages[localStorage.getItem(langKey)]['all']['hour'] : '小时'
    const mText = isLangMatched ? messages[localStorage.getItem(langKey)]['all']['minute'] : '分'
    const sText = isLangMatched ? messages[localStorage.getItem(langKey)]['all']['second'] : '秒'

    const sPerMinute = 60
    const sPerHour = 60*60
    const sPerDay = 24*60*60
    const days = total/sPerDay > 0 ? parseInt(total/sPerDay) : 0
    const hours = (total%sPerDay)/sPerHour > 0 ? parseInt((total%sPerDay)/sPerHour) : 0
    const minites = (total%sPerDay)%sPerHour > sPerMinute ? parseInt(((total%sPerDay)%sPerHour)/sPerMinute) : 0
    const seconds = total%sPerDay%sPerHour%sPerMinute
    const dayStr = days ? `${days}${dText}` : ''
    const hourStr = hours ? `${hours}${hText}` : ''
    const miniStr = minites ? `${minites}${mText}` : ''
    const secStr = seconds ? `${seconds}${sText}` : ''
  
    return {
      'd': days,
      'h': hours,
      'm': minites,
      's': seconds,
      'str': `${dayStr}${hourStr}${miniStr}${secStr}`
    }
  },
  checkBrowser(){
    // 检查浏览器版本
    const limit = browserVersion
    let version = 0
    const ua = navigator.userAgent.toLowerCase();
    const chromeInfo = ua.match(/chrome\/([\d.]+)/)
    if (chromeInfo) {
      version = chromeInfo[1]
    }

    if (parseInt(version) < limit) {
      return false
    }

    return true
  },
  generateCode(code, type = 'datamatrix') {
    // 生成各种码图像
    // 支持的code列表：https://github.com/metafloor/bwip-js/wiki/BWIPP-Barcode-Types
    if (codeCanvas) {
      codeCanvas = null
    }

    codeCanvas = document.createElement('canvas')
    const opts = {
      bcid: type,
      text: `${code}`,
      textxalign: 'center' 
    }

    try {
      bwipjs.toCanvas(codeCanvas, opts)
      const base64 = codeCanvas.toDataURL('image/png')
      
      return base64
    } catch (error) {
      console.log('生成码出错', error)
    }
  },
  async print(data, type= 'tag') {
    // 打印标签: type默认为tag标签，sterilize为灭菌标签，page为打印清单
    const id = '_printTagIframe'
    let url = `${window.location.origin}${this.siteBase()}printTag/index.html`
    if (type === 'sterilize') {
      url = `${window.location.origin}${this.siteBase()}printSterilize/index.html`
    } else if (type === 'page') {
      url = `${window.location.origin}${this.siteBase()}printPage/index.html`
    } else if (type === 'photo') {
      url = `${window.location.origin}${this.siteBase()}printPhoto/index.html`
    } else if (type === 'list') {
      url = `${window.location.origin}${this.siteBase()}printList/index.html`
    } else if (type === 'report') {
      url = `${window.location.origin}${this.siteBase()}printReport/index.html`
    } else if (type === 'encode') {
      url = `${window.location.origin}${this.siteBase()}printEncode/index.html`
    } else if (type === 'inventory') {
      url = `${window.location.origin}${this.siteBase()}printInventory/index.html`
    } else if (type === 'smartTag') {
      url = `${window.location.origin}${this.siteBase()}printSmartTag/index.html`
    } else if (type === 'quality') {
      url = `${window.location.origin}${this.siteBase()}printQuality/index.html`
    } else if (type === 'createQRCode') {
      url = `${window.location.origin}${this.siteBase()}printCreateQRCode/index.html`
    }

    if (type === 'tag' && data.labelformat < 0) {
      const labelId = data.labelformat * -1
      const templateDetail = await tagMixin.methods._getSmartTagDetail.bind(Vue.prototype, labelId)()
      const templateData = tagMixin.methods._parseSmartTagConfigByDetail(templateDetail)
      if (!templateData) return
      const printData = {
        ins_code: data.ins_code || []
      }

      if (data.pack_code_list && data.pack_code_list.length) {
        const { list, total } = tagMixin.methods._collapseBatch(data.pack_code_list)
        printData.batch_list = [
          {
            pack_code: data.pack_code || '0',
            list,
            _total: total
          }
        ]
      }
      
      const printElementString = tagMixin.methods._generatePrintHtml(templateData, printData)
      if (!printElementString.replace(/\s/g, '')) {
        Vue.prototype.$message({
          message: '没有可打印的内容，请检查数据和标签设置',
          type: 'error'
        })

        return
      }
      
      this.print(printElementString, 'smartTag')
      return
    }

    let iframe = document.querySelector(`#${id}`)
    if (iframe) {
      document.body.removeChild(iframe)
      this.print(data, type)
    } else {
      iframe = document.createElement('iframe')
      iframe.onload = () => {
        iframe.contentWindow.p = data

        if (iframe.contentWindow.printEvt) {
          iframe.contentWindow.printEvt()
        } else {
          const btn = iframe.contentWindow.document.querySelector('#print')
          
          btn.click()
        }
      }
      iframe.src = url
      iframe.style.display = 'none'
      iframe.id = id
      document.body.appendChild(iframe)
    }
  },
  getTimeRange({start=0, end=0, point=0}) {
    // 获取时间范围，以ponit为时间基准点，获取一个时间范围
    // 单位为秒
    if (start === null || end === null) {
      return []
    }

    const basePoint = moment().startOf('day').unix() + point // 时间基准点
    const startString = moment((basePoint + start)*1000).format('yyyy-MM-DD HH:mm:ss')
    const endString = moment((basePoint + end)*1000).format('yyyy-MM-DD HH:mm:ss')

    return [startString, endString]
  },
  washObject(obj) {
    // 清洗对象，将undefined的key删除（改变原对象）
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const value = obj[key]
        if (value === undefined) {
          delete obj[key]
        }
      }
    }

    return obj
  },
  setLocalLabel(key, value) {
    // 设置标签号
    const localData = this.getLocal(localLabelKey) || {}
    localData[key] = value

    this.setLocal(localLabelKey, localData)
  },
  getLocalLabel(key) {
    // 获取标签号
    const localData = this.getLocal(localLabelKey) || {}

    return localData[key]
  },
  setLocal(key, value) {
    // 存储localstorage
    let string = value
    if (typeof(value) === 'object') {
      string = JSON.stringify(value)
    }

    localStorage.setItem(key, string)
  },
  getLocal(key){
    // 获取localstorage
    const s = localStorage.getItem(key)
    let str = ''
    if (s) {
      try {
        str = JSON.parse(s)
      } catch (error) {
        console.log('解析loalStoage报错:', error)
        str = s
      }

      return str
    }
    
    return null
  },
  delLocal(key) {
    // 清除localstorage
    localStorage.removeItem(key)
  },
  handleTimeOptions(times = []) {
    // 整理时间选项
    const startTime = times.length ? Math.min(...times) : null
    const endTime = times.length ? Math.max(...times) : null

    return this.getTimeRange({start: startTime, end: endTime})
  },
  unAttachScan() {
    // 解绑扫码组件
    Vue.prototype.$scan(window.document, { unAttach: true })
  },
  scrollIntoView(dom) {
    dom.scrollIntoView()
  },
  confirm({ title, msg, confirmButtonText, cancelButtonText, type }) {
    // 自定义confirm
    title = title || ''
    msg = msg || ''

    confirmButtonText = confirmButtonText || (isLangMatched ? messages[localStorage.getItem(langKey)]['action']['confirm'] : '确定')
    cancelButtonText = cancelButtonText || (isLangMatched ? messages[localStorage.getItem(langKey)]['action']['cancel'] : '取消')
    type = type || ''
    return new Promise((resolve) => {
      Vue.prototype.$confirm(msg, title, {
        confirmButtonText, cancelButtonText, type
      })
      .then(() => {
        resolve(true)
      })
      .catch(() => {
        resolve(false)
      })
    })
  },
  checkType(data) {
    // 检查数据类型
    const match = Object.prototype.toString.apply(data).match(/\s.*\]$/g)
    const type = (match && match[0]) ? match[0].substring(1, match[0].length - 1) : ''

    return type.toLowerCase()
  },
  handOverStatus(code) {
    // 检查包的物品交接状态
    const { checkInstrumentSetHandOverStatus } = api
    
    return request('get', checkInstrumentSetHandOverStatus, { code })
  },
  isDate(string) {
    // 判断字符串是时间日期格式
    const dateTimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

    return dateTimeRegex.test(string)
  },
  matchChinese(string, split = '') {
    // 匹配字符串中的中文（简、繁体）
    const matched = string.match(/[\u4e00-\u9fa5]+/g)
    if (matched && matched.length) {
      return matched.join(split)
    }
    
    return ''
  },
  getNextWeekDay(format) {
    // 获取下个工作日，有format会按照format返回，否则返回时间戳
    const now = storeInstance.state.system.time
    const todayWeekDay = moment(now).weekday()
    const nextWeekDayGap = todayWeekDay < 4 ? 1 : (7 - todayWeekDay)
    const nextWeekDay = moment(now).add(nextWeekDayGap, 'd').startOf('day')

    return format ? nextWeekDay.format(format) : nextWeekDay.unix() * 1000
  },
  saveAsFile(data) {
    // 保存文件
    const { content, fileName, type } = data
    const blob = new Blob([content], {
      type: type || 'application/text'
    })
    
    const aTag = window.document.createElement('a')
    if ('download' in aTag) {
      aTag.download = fileName
      aTag.style.display = 'none'
      aTag.href = URL.createObjectURL(blob)
      window.document.body.appendChild(aTag)
      aTag.click()
      URL.revokeObjectURL(aTag.href)
      window.document.body.removeChild(aTag)
    } else {
      window.navigator.msSaveBlob(blob, fileName)
    }
  },
  sameDataArray(a, b) {
    // 判断两个数组是否相同（用于判断数据）
    return (a.length === b.length) && (a.sort().toString() === b.sort().toString())
  },
  printWarningConfirm(msg = '') {
    // 扣除打印次数确认提醒
    return new Promise(r => {
      request('get', api.isFirstPrint).then((res =>{
        if (res.is_printed === 0) {
            this.confirm({ msg }).then(f => {
              r(f)
            })
        } else r(true)
      }))
      // const warning = localStorage.getItem(printWarningKey)
      // if (warning) {
      //   r(true)
      // } else {
      //   this.confirm({ msg })
      //   .then(res => {
      //     localStorage.setItem(printWarningKey, 1)
          
      //     r(res)
      //   })
      // }
    })
  },
  deepCopy(obj) {
    if (typeof obj !== 'object' || obj === null) {
      // 如果不是对象或为null，直接返回
      return obj;
    }
  
    // 创建一个空对象或数组，用于存储拷贝后的数据
    const result = Array.isArray(obj) ? [] : {};
  
    // 遍历原对象或数组的属性或元素
    for (const key in obj) {
      // 检查是否为对象自身属性（非原型链上的属性）
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        // 递归调用deepCopy函数，实现深拷贝
        result[key] = this.deepCopy(obj[key]);
      }
    }
  
    return result;
  },
  siteBase() {
    const { VUE_APP_BASE } = process.env

    return VUE_APP_BASE ? `/${VUE_APP_BASE}/` : '/'
  },
  isEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    
    return emailPattern.test(email);
  },
}